<svg width="48" height="28" viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="48" height="28" rx="4" fill="#FFFFFF" />
  <circle cx="19" cy="14" r="7" fill="#0061A8" />
  <circle cx="29" cy="14" r="7" fill="#EB001B" />
  <path d="M24 8.8a7 7 0 0 1 0 10.4 7 7 0 0 1 0-10.4z" fill="#7B2C82" />
</svg>
